export const namespace = 'toasts'
